import {useInitialLocation} from './context';
import {useSearch} from './useLocation';
import {UTM_PARAMS} from './utmParams';

export function useUtmParams() {
  const search = useSearch();
  const originalParams = new URLSearchParams(search);

  const utmParams = new URLSearchParams();

  originalParams.forEach((value, key) => {
    if ((UTM_PARAMS as Set<string>).has(key)) {
      utmParams.set(key, value);
    }
  });
  return utmParams;
}

export function useInitialUtmParams() {
  const {search} = useInitialLocation();
  const originalParams = new URLSearchParams(search);

  const utmParams = new URLSearchParams();

  originalParams.forEach((value, key) => {
    if ((UTM_PARAMS as Set<string>).has(key)) {
      utmParams.set(key, value);
    }
  });
  return utmParams;
}
